module.exports = __webpack_public_path__ + "static/media/GuessWise.dbdcd0b6.png";